import React from "react";
import { Buttons } from "./Buttons";
import { FaTimes } from "react-icons/fa";

const PageTitle = ({ title, PageTitle: pageTitleProp, showButton = false, CloseClick }) => {
  const displayTitle = title || pageTitleProp || "";

  return (
    <div className="d-flex justify-content-between align-items-center">
      <div>
        <h4 className="fw-bold text-dark m-0">{displayTitle}</h4>
      </div>
      {showButton && (
        <div>
          <Buttons
            className="action-btn text-muted"
            btnlabel={<FaTimes size={18} />}
            onClick={CloseClick}
          />
        </div>
      )}
    </div>
  );
};

export default PageTitle;
